import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const QMSCard = ({
  title,
  logo,
  subheader,
  description,
  actions,
  lastInternalAudit,
  nextInternalAudit,
  lastExternalAudit,
  nextExternalAudit,
}) => {
  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardHeader
        avatar={
          <Avatar
            alt="avatar"
            variant="square"
            src={logo}
            sx={{ width: 40, height: 40 }}
          />
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title={title}
        subheader={`Desde: ${subheader}`}
      />
      <hr></hr>
      <CardContent sx={{ height: "250px", mt: 2 }}>
        <Typography sx={{ mb: 2 }} variant="body2" color="text.secondary">
          {description}
        </Typography>
        <Typography variant="body3" color="text.secondary" sx={{ fontWeight: 'bold' }}>
          Auditoria Interna:
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Última: {lastInternalAudit}
        </Typography>
        <Typography sx={{ mb: 2 }} variant="body2" color="text.secondary">
          Próxima: {nextInternalAudit}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold' }}>
          Auditoria Externa:
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Última: {lastExternalAudit}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Próxima: {nextExternalAudit}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default QMSCard;
